<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body" style="padding: 8px;">
                    <div class="row">
                        <div class="col-md-12">
                            <select2 name="Affiliate"
                                     :data="affiliates"
                                     :selected="filters.affiliate"
                                     :minSelection="1"
                                     v-on:onChange="onAffiliateFilterChanged" />
                        </div>
                    </div>
                </div>
            </div>
            <autoupdate :loading="reportDataLoading" v-on:refreshData="loadData" />
            <div class="box">
                <div class="box-header" style="padding-top: 3px; padding-bottom:3px;">&nbsp;</div>
                <div class="box-tool" style="top: 4px;">
                    <ul class="nav">
                        <li class="nav-item inline">
                            <a class="nav-link" v-on:click="downloadCsv"><span class="fa fa-download"></span></a>
                        </li>
                    </ul>
                </div>
                <table2 :rows="data" :headers="tableHeaders" :hasTotalRow="true" />
            </div>
        </div>
    </div>
</template>

<script>
    import parallel from 'async/parallel';
    import Select2 from '../../../components/select.v2.vue';
    import $ from 'jquery';
    import AutoUpdate from '../../../components/auto_update.vue';
    import Table2 from '../../../components/table.v2.vue';
    import map from 'lodash.map';
    import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

    export default {
        mixins: [TimezoneChangeMixin],
        components: {
            'select2': Select2,
            'autoupdate': AutoUpdate,
            'table2': Table2
        },
        data: function () {
            return {
                filters: {
                    affiliate: []
                },
                affiliates: [],
                data: [],
                tableHeaders: [
                    {
                        columnName: 'country',
                        title: 'Ülke',
                        dataFormat: 'string'
                    },
                    {
                        columnName: 'population',
                        title: 'Nüfus',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'total_unique',
                        title: 'Toplam Eşsiz',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'total',
                        title: 'Toplam',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'population_coverage',
                        title: 'Nüfus Kapsama',
                        dataFormat: 'integer',
                        regex: "[0-9]+"
                    },
                    {
                        columnName: 'new_unique',
                        title: 'Yeni Gelen Eşsiz',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'new',
                        title: 'Yeni Gelen',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    }
                ],
                loading: false,
                reportDataLoading: false,
                csvDownloadUrl: ''
            }
        },
        mounted: function () {
            var $this = this;
            this.loading = true;
            parallel([
                function (next) {
                    var params = {id: $this.$router.currentRoute.query.id};
                    $this.$app.get('/api/v1/dashboards/report/getcontact/affiliate-names', params, function(xhr) {
                        var response = xhr.responseJSON;
                        $this.affiliates = $.map(response.affiliates, function (affiliate) {
                            return {
                                id: affiliate.id,
                                text: affiliate.name
                            }
                        });
                        var savedAffiliate = $this.$app.getValue('getcontact.affiliate.v2');
                        if (savedAffiliate !== null) {
                            $this.filters.affiliate = savedAffiliate;
                        } else {
                            $this.filters.affiliate = map($this.affiliates, 'id');
                        }
                        next();
                    });
                }
            ], function (err, results) {
                $this.loading = false;
                $this.loadData();
            });
        },
        methods: {
            loadData: function () {
                this.reportDataLoading = true;
                var $this = this;
                var params = {
                    id: this.$router.currentRoute.query.id,
                    affiliate: this.filters.affiliate
                };
                this.$app.get('/api/v1/dashboards/report/getcontact/msisdn-summary-data', params, function(xhr) {
                    $this.reportDataLoading = false;
                    var response = xhr.responseJSON;
                    $this.data = response.data;
                    params.access_token = $this.$app.getAccessToken();
                    params.csv = 1;
                    $this.csvDownloadUrl = '/api/v1/dashboards/report/getcontact/msisdn-summary-data?' + $.param(params);
                }, {'Timezone': this.$app.getTimezone()});
            },
            downloadCsv: function () {
                if (this.csvDownloadUrl !== '') {
                    window.open(this.csvDownloadUrl);
                }
            },
            onAffiliateFilterChanged: function (data) {
                this.filters.affiliate = data;
                this.$app.setValue('getcontact.affiliate.v2', data);
                this.loadData();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// msisdn_summary.vue?45a5b942